import { useRouter } from "next/router";
import { ImpactType } from "@ecologi/shared";

export function useImpactShopFilter(): {
  impactType: ImpactType | null;
  setImpactType: (impactType: ImpactType | null) => void;
} {
  const router = useRouter();

  const setImpactType = (impactType: ImpactType | null) => {
    router.push(
      {
        pathname: router.pathname,
        query: impactType ? { impactType } : {},
      },
      undefined,
      { shallow: true }
    );
  };

  const impactType = router.query.impactType;
  if (isImpactType(impactType)) {
    return { impactType, setImpactType };
  } else {
    return { impactType: null, setImpactType };
  }
}

function isImpactType(
  value: string | string[] | undefined
): value is ImpactType {
  return typeof value === "string" && Object.keys(ImpactType).includes(value);
}
